import { useTranslation } from 'react-i18next'

import { useInlineNotifications } from '../../../../hooks'
import { FormikForm } from '../../../Formik'
import { ProfileContactsWidgetListCellEditFields } from '../ProfileContactsWidgetListCellEditFields'

import { getValidationSchema } from './ProfileContactsWidgetListCellEdit.utils'

function ProfileContactsWidgetListCellEdit({
  canDelete,
  infoTooltipKey,
  initialValues,
  isDeleteValue,
  label,
  name,
  qaId,
  typeConfig,
  onClick,
  onDelete,
  onDirtyChange,
  onSubmit,
}) {
  const { t } = useTranslation()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema = getValidationSchema({ initialValues, t, typeConfig })

  return (
    <FormikForm
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={typeConfig.isPhone}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <ProfileContactsWidgetListCellEditFields
        canDelete={canDelete}
        infoTooltipKey={infoTooltipKey}
        isDeleteValue={isDeleteValue}
        label={label}
        name={name}
        notifications={notifications}
        qaId={qaId}
        typeConfig={typeConfig}
        onClick={onClick}
        onDelete={onDelete}
        onDirtyChange={onDirtyChange}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ProfileContactsWidgetListCellEdit
